import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  DataApiResponseLegacy,
  GeneralLedgerAccountGroupModel,
  GeneralLedgerAccountModel,
} from '@digilize/shared/definitions/src';

@Injectable({ providedIn: 'root' })
export class GeneralLedgerAccountGroupService {
  readonly GENERAL_LEDGER_GROUP_URL = '/api/v1.0/general-ledger-account-group';

  constructor(private http: HttpClient) {}

  /* Serialises the DataTables envelope in camelCase (`recordsFiltered`), not the snake_case
     swagger documents for it — hence DataApiResponseLegacy. Omitting `length` returns every group
     (the backend only pages when length > 0), which is what the account form's picker relies on. */
  getGroupsList(params) {
    return this.http.get<DataApiResponseLegacy<GeneralLedgerAccountGroupModel[]>>(`${this.GENERAL_LEDGER_GROUP_URL}`, {
      params,
    });
  }

  getGroupDetails(id: string) {
    return this.http.get<GeneralLedgerAccountGroupModel>(`${this.GENERAL_LEDGER_GROUP_URL}/${id}`);
  }

  addGroup(data: GeneralLedgerAccountGroupModel) {
    return this.http.post<GeneralLedgerAccountGroupModel>(`${this.GENERAL_LEDGER_GROUP_URL}`, data);
  }

  editGroup(data: GeneralLedgerAccountGroupModel) {
    return this.http.put<GeneralLedgerAccountGroupModel>(`${this.GENERAL_LEDGER_GROUP_URL}`, data);
  }

  removeGroup(id: string) {
    return this.http.delete(`${this.GENERAL_LEDGER_GROUP_URL}/${id}`);
  }

  /* Unpaged plain array, not a DataTables envelope — a group holds tens of accounts. */
  getGroupAccounts(id: string) {
    return this.http.get<GeneralLedgerAccountModel[]>(`${this.GENERAL_LEDGER_GROUP_URL}/${id}/accounts`);
  }
}
